module.exports = __webpack_public_path__ + "img/marketplace.1d1fda69.svg";